import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { TransactionResponse } from '../types/transaction';

const useTransactions = (domain: string, startDate: string, endDate: string, statusPaid: string, status: string) => {
  const [data, setData] = useState<TransactionResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [domains, setDomains] = useState<string[]>([]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const params: Record<string, string> = {};
      if (domain) params.domain = domain;
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      if (statusPaid) params.status_paid = statusPaid;
      if (status !== '') params.status = status;

      const response = await axios.get<TransactionResponse>('https://azpay.devng.pro/api/transactions', { params });
      setData(response.data);
      
      // ดึงรายการ Domain ที่ไม่ซ้ำกัน
      const uniqueDomains = Array.from(new Set(response.data.data.transactions.map(t => t.domain)));
      setDomains(uniqueDomains);
      setError(null);
    } catch (err) {
      setError('เกิดข้อผิดพลาดในการโหลดข้อมูล');
    } finally {
      setLoading(false);
    }
  }, [domain, startDate, endDate, statusPaid, status]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, domains, refetch: fetchData };
};

export default useTransactions;
